// removed by extract-text-webpack-plugin
module.exports = {"Modal":"StartingModal__-loca-__2NMz9","CloseButton":"StartingModal__-loca-__1pulG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/StartingModal/StartingModal.css
// module id = 215
// module chunks = 0